import React from "react";
import RealAux from './../../hoc/RealAux';
import Message from "./Message";

// import classes from './Messages.css';

class Messages extends React.Component {
    constructor(props) {
        super(props);
    }
        state={
        showItems:false,
        messagesItems:this.props.items
    }
   
      
    togglePersonsHandler = () => {
        const doesShow = this.state.showItems;
        this.setState({showItems : !doesShow});
    }

    render() {
        let messagesWP = '';
        let iconClass =this.state.showItems ? 'fa-minus-square' : 'fa-plus-square';
            messagesWP = this.props.items.map((item,index) => (
                <Message data={item} showItems={this.state.showItems} itemNum={index} clicked={this.togglePersonsHandler} key={"message_"+index}/> 
            ))

        return (
            <React.Fragment>
            <div className="col-10 col-md-8">
                <div className="row">
                    {messagesWP}
                </div>
             </div>
             <div className="col-2 col-md-4  btn-group" >
                 <button type="button"  className="btn messagesBtn" data-toggle="collapse" 
                 data-target=".messages-multi-collapse"
                    aria-expanded="false" onClick={this.togglePersonsHandler}><span className="btnText">כל ההודעות</span><i className={'far '+iconClass}></i></button>
            </div>
            </React.Fragment>
        );
    };
    
}

export default Messages;